import React, { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { observer } from "mobx-react";
import { Collapse } from "react-bootstrap";

import { useAppStore } from "../../providers/AppStoreProvider";
import { CourseProgress } from "./CourseProgress";
import { CreateLesson, Lesson } from "./Lesson/Lesson";
import { Chapter, CreateChapter } from "./Chapter/Chapter";

import "./Playlist.scss";

export const Playlist = observer(() => {
  const store = useAppStore();
  const { lessonId } = useParams();
  const [openedChapter, setOpenedChater] = useState([]);
  const playlistRef = useRef();

  const refs = useMemo(
    () =>
      store.lessons.reduce((refArr, lesson) => {
        refArr[lesson.id] = React.createRef();
        return refArr;
      }, {}),
    [store.lessons],
  );

  useEffect(() => {
    const chapter = store.lessons.find((lesson) => lesson.id === parseInt(lessonId))?.chapter;

    if (chapter) {
      setOpenedChater([chapter.id]);
      setTimeout(() => {
        playlistRef.current.scrollTop =
          // 1px for box border
          refs[lessonId].current.offsetTop - playlistRef.current.offsetTop - 1;
      }, 1200);
    }
  }, []);

  const createLessonHandler = (chapterId) => {
    store.lessonModal.setMode("create");
    // store.lessonModal.setEntityId(chapterId);
    store.lessonModal.toggle();
  };

  const createChapterHandler = () => {
    store.chapterModal.setMode("create");
    store.chapterModal.toggle();
  };

  return (
    <div className="playlist">
      <CourseProgress />

      <div ref={playlistRef} className="playlist-chapters">
        {store.chapters.map((chapter, chapterIndex) => {
          return (
            <div className="chapter-container" key={chapter.id}>
              <Chapter
                chapter={chapter}
                index={chapterIndex}
                isOpen={openedChapter.includes(chapter.id)}
                onOpen={() => setOpenedChater((currState) => [...currState, chapter.id])}
                onClose={() =>
                  setOpenedChater((currState) => currState.filter((c) => c !== chapter.id))
                }
              />
              <Collapse className="chapter-lessons" in={openedChapter.includes(chapter.id)}>
                <div id={`chapter-${chapter.id}`}>
                  {chapter.lessons.map((lesson, lessonIndex) => (
                    <Lesson
                      ref={refs[lesson.id]}
                      key={`lesson-${lesson.id}`}
                      lesson={lesson}
                      index={lessonIndex}
                    />
                  ))}
                  {store.hasPermission("create_lesson") && (
                    <CreateLesson onClick={() => createLessonHandler(chapter.id)} />
                  )}
                </div>
              </Collapse>
            </div>
          );
        })}
        {store.hasPermission("create_chapter") && <CreateChapter onClick={createChapterHandler} />}
      </div>
    </div>
  );
});
